import { render } from "./CobrowseConfiguration.vue?vue&type=template&id=0ee8c760&scoped=true&lang=pug"
import script from "./CobrowseConfiguration.vue?vue&type=script&lang=js"
export * from "./CobrowseConfiguration.vue?vue&type=script&lang=js"

import "./CobrowseConfiguration.vue?vue&type=style&index=0&id=0ee8c760&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee8c760"]])

export default __exports__